import useFeatureCustomization from "brand-customization/useFeatureCustomization";
const useInvestigationReportingByAICustomization = () => useFeatureCustomization("aiInvestigationReport");
export default useInvestigationReportingByAICustomization;
